<div class="padding-small bg-light-grey padding-left-large small">
  <div class="flex center">
    <span class="primary hover" (click)="onBack()">Manage orders</span>
    <i class="fa-solid fa-angle-right padding-right-small padding-left-small grey"></i>
    {{ isCreateMode ? 'New order' : 'Order details' }}
  </div>
</div>

<div class="flex center bg-white border-bottom">
  @for (tab of tabs; track tab) {
    <div
      class="padding hover"
      [ngClass]="{ 'bg-primary white': tab.url === activeSubRoute, disabled: tab.disabled }"
      (click)="selectTab(tab.url)"
    >
      <i class="fa-solid fa-angle-down margin-right-small"></i>
      {{ tab.title }}
    </div>
  }
</div>

<router-outlet />
